import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' },
        { type: 'required', message: 'Please provide a phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    ClientName: {
      validations: []
    },
    AddressLine1: {
      validations: [
        { type: 'required', message: 'Please provide an address' }
      ]
    },
    City: {
      validations: [
        { type: 'required', message: 'Please provide a city' }
      ]
    },
    State: {
      validations: [{ type: 'required', message: 'Please provide a state' }]
    },
    Postal: {
      validations: [
        { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }, 
        { type: 'required', message: 'Please provide a zip code' }
      ]
    },
    accountextra1: {
      validations: [{ type: 'required', message: 'Please select an option' }]
    },
    accountextra2: {
      validations: []
    },
    accountextra3: {
      validations: [{ type: 'required', message: 'Please select an option' }
    ]
    },
    accountextra4: {
      validations: [
        { type: 'required', message: 'Please select an option' }
      ]
    },
    accountextra5: {
      validations: [
        { type: 'required', message: 'Please select an option' }
      ]
    },
    accountextra6: {
      validations: [
        { type: 'required', message: 'Please select an option' }
      ]
    },
    accountextra7: {
      validations: []
    },
    Description: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:*',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company Name:',
            mapping: 'ClientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address:*',
            mapping: 'AddressLine1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City:*',
            mapping: 'City'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State:*',
            options: [
              { label: 'AL', value: 'AL' },
              { label: 'AK', value: 'AK' },
              { label: 'AZ', value: 'AZ' },
              { label: 'AR', value: 'AR' },
              { label: 'CA', value: 'CA' },
              { label: 'CO', value: 'CO' },
              { label: 'CT', value: 'CT' },
              { label: 'DE', value: 'DE' },
              { label: 'DC', value: 'DC' },
              { label: 'FL', value: 'FL' },
              { label: 'GA', value: 'GA' },
              { label: 'HI', value: 'HI' },
              { label: 'ID', value: 'ID' },
              { label: 'IL', value: 'IL' },
              { label: 'IN', value: 'IN' },
              { label: 'IA', value: 'IA' },
              { label: 'KS', value: 'KS' },
              { label: 'KY', value: 'KY' },
              { label: 'LA', value: 'LA' },
              { label: 'ME', value: 'ME' },
              { label: 'MD', value: 'MD' },
              { label: 'MA', value: 'MA' },
              { label: 'MI', value: 'MI' },
              { label: 'MN', value: 'MN' },
              { label: 'MS', value: 'MS' },
              { label: 'MO', value: 'MO' },
              { label: 'MT', value: 'MT' },
              { label: 'NE', value: 'NE' },
              { label: 'NV', value: 'NV' },
              { label: 'NH', value: 'NH' },
              { label: 'NJ', value: 'NJ' },
              { label: 'NM', value: 'NM' },
              { label: 'NY', value: 'NY' },
              { label: 'NC', value: 'NC' },
              { label: 'ND', value: 'ND' },
              { label: 'OH', value: 'OH' },
              { label: 'OK', value: 'OK' },
              { label: 'OR', value: 'OR' },
              { label: 'PA', value: 'PA' },
              { label: 'RI', value: 'RI' },
              { label: 'SC', value: 'SC' },
              { label: 'SD', value: 'SD' },
              { label: 'TN', value: 'TN' },
              { label: 'TX', value: 'TX' },
              { label: 'UT', value: 'UT' },
              { label: 'VT', value: 'VT' },
              { label: 'VA', value: 'VA' },
              { label: 'WA', value: 'WA' },
              { label: 'WV', value: 'WV' },
              { label: 'WI', value: 'WI' },
              { label: 'WY', value: 'WY' }
            ],
            mapping: 'State'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip:*',
            mapping: 'Postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Catering Type:*',
            options:[
              {label: "On-Premise" , value: "On-Premise"},
              {label: "Off-Premise" , value: "Off-Premise"},
            ],
            mapping: 'accountextra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Room Requested (For On-Premise Only):',
            options:[
              {label: "Beer Hall/Biergarten" , value: "Beer Hall/Biergarten"},
              {label: "Blue Room" , value: "Blue Room"},
              {label: "Grand Ballroom" , value: "Grand Ballroom"},
              {label: "Gold Room" , value: "Gold Room" },
              {label: "Nassau-Franklin Room" , value: "Nassau-Franklin Room" },
              {label: "Green Room" , value: "Green Room"},
              {label: "Meeting Room" , value: "Meeting Room"},
            ],
            mapping: 'accountextra2'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type:*',
            options:[
              {label: "Wedding" , value: "Wedding"},
              {label: "Milestone" , value: "Milestone"},
              {label: "Birthday" , value: "Birthday"},
              {label: "Corporate" , value: "Corporate"},
              {label: "Other" , value: "Other"},
            ],
            mapping: 'accountextra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Amount of People:*',
            options:[
              {label: "20 or less" , value: "20 or less"},
              {label: "21-50" , value: "21-50"},
              {label: "51-75" , value: "51-75"},
              {label: "76-100" , value: "76-100" },
              {label: "101 or more" , value: "101 or more"},
            ],
            mapping: 'accountextra4'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Date Requested:*',
            mapping: 'accountextra5'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Time Requested:*',
            options:[
              {label: "Morning" , value: "Morning"},
              {label: "Afternoon" , value: "Afternoon"},
              {label: "Evening" , value: "Evening"},
            ],
            mapping: 'accountextra6'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us?:',
            options:[
              {label: "Family or Friend" , value: "Family or Friend"},
              {label: "Facebook" , value: "Facebook"},
              {label: "Instagram" , value: "Instagram"},
              {label: "News/Online" , value: "News/Online"},
              {label: "Online" , value: "Online"},
              {label: "Other" , value: "Other"},
            ],
            mapping: 'accountextra7'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Comments',
            mapping: 'Description'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Plattduetsche Park Restaurant Contact Form',
    formId: '722',
    clientKey: '1D483005-9CED-4677-B539-E3B43BAF5881',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://parkrestaurant.com/cat-req-ty/',
    submissionText: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
